"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));
var _semanticUiReact = require("semantic-ui-react");
var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FemaGoModal = function FemaGoModal(props) {
  var htmlContent = props.htmlContent;
  var ignoreDefaultWithCancel = function ignoreDefaultWithCancel(e) {
    e.preventDefault();
    props.cancelAction();
  };
  var ignoreDefaultWithConfirm = function ignoreDefaultWithConfirm(e) {
    e.stopPropagation();
    e.preventDefault();
    props.confirmAction(e);
  };
  var onOpen = function onOpen(e, o) {};
  return !!props.open && /*#__PURE__*/_react.default.createElement(_focusTrapReact.default, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Modal, {
    open: props.open,
    closeOnDimmerClick: props.closeOnDimmerClick === 'no' ? false : true,
    size: props.size ? props.size : 'tiny',
    className: props.className ? props.className : '',
    onClose: props.cancelAction || props.onClose
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Modal.Content, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Header, {
    as: "h2",
    content: props.title
  }), htmlContent && (0, _reactHtmlParser.default)(props.htmlContent), props.displayHtml ? (0, _reactHtmlParser.default)(props.children) : props.children, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form, {
    style: {
      paddingTop: '24px',
      display: 'flex',
      justifyContent: 'flex-start',
      justifyItems: 'flex-start',
      alignItems: 'center',
      gap: '16px'
    }
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, {
    style: {
      borderCollapse: 'collapse',
      visibility: props.confirmButton ? props.confirmButton : 'visible'
    }
  }, !props.readOnly && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Button, {
    title: props.buttonText ? props.buttonText : 'Confirm',
    primary: props.type && props.type === 'alert' ? undefined : true,
    onClick: ignoreDefaultWithConfirm,
    disabled: props.disableButton,
    color: props.type && props.type === 'alert' ? 'red' : undefined
  }, props.buttonText ? props.buttonText : 'Confirm')), !props.hideCancel && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    onClick: ignoreDefaultWithCancel,
    title: props.cancelButtonText || 'Cancel'
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
    name: "cancel"
  }), props.cancelButtonText || 'Cancel'))))));
};
FemaGoModal.defaultProps = {
  readOnly: false
};
FemaGoModal.propTypes = {
  buttonText: _propTypes.default.string,
  className: _propTypes.default.string,
  size: _propTypes.default.string,
  type: _propTypes.default.string,
  closeOnDimmerClick: _propTypes.default.string,
  title: _propTypes.default.string.isRequired,
  open: _propTypes.default.any.isRequired,
  cancelAction: _propTypes.default.func.isRequired,
  confirmAction: _propTypes.default.func.isRequired
};
var _default = FemaGoModal;
exports.default = _default;